import * as React from 'react';

import * as style from './SeoTopBannersLayout.css';

export const SeoTopBannersLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={style['container']} data-name="SeoTopBanners">
      {children}
    </div>
  );
};
